import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {GET_LIST, GET_ONE, CREATE, UPDATE, DELETE, DELETE_MANY} from 'react-admin';

import {HTTP_GET, HTTP_POST, HTTP_DELETE} from '../common/HttpService';
//import {useEffect} from 'react';

const resourceBaseUlr = apiUrl + '/vendors';

export const getVendor = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  preprocess(res.data);
  return res;
};

const getVendors = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;

  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(params.filter)
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  res.data.map((e) => {
    preprocess(e);
  });
  return res;
};

const preprocess = (d) => {
  if (!d || !d.profession || !Array.isArray(d.profession)) return;
  let prof = d.profession;
  d.profession = [];
  prof.map((e) => {
    if (typeof e === 'object' && e !== null && 'key' in e) {
      d.profession.push(e);
    } else {
      d.profession.push({key: e});
    }
  });
};

const postprocess = (d) => {
  if (!d) return d;
  const data = {...d};
  if (Array.isArray(data.profession)) {
    data.profession = data.profession
      .map((e) => {
        if (typeof e === 'object' && e !== null) {
          return e.key || e.name || e.title || Object.values(e)[0] || '';
        }
        return e;
      })
      .filter(Boolean);
  }
  return data;
};

const createVendor = async (params) => {
  const url = `${resourceBaseUlr}` + '/createvendor';
  const body = postprocess(params.data);
  body.userRole = '0';
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const updateVendor = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  const body = postprocess(params.data);
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteVendor = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_DELETE(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteMany = async (params) => {
  const url = `${resourceBaseUlr}`;
  const body = params;
  let res = await HTTP_DELETE(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const VendorsDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getVendors(params);

    case GET_ONE:
      return getVendor(params);

    case CREATE:
      return createVendor(params);

    case UPDATE:
      return updateVendor(params);

    case DELETE:
      return deleteVendor(params);

    case DELETE_MANY:
      return deleteMany(params);

    default:
      return Promise.reject('Unknown Type');
  }
};

export default VendorsDataProvider;
